import './utils/vh.utils.js';
import './utils/animate-on-view.utils';
import './utils/parallax-on-view.utils.js';

import './components/header.component.js';
import './components/uploadFile.component.js';
import './components/inputs.component.js';
import './components/animations.component.js';
import './components/buttons.component.js';
import './components/ranges.component.js';

import './components/marquee.component.js';
import './components/together.component.js';
import './components/our-services.component.js';
import './components/contact-form.component.js';
import './components/our-location.component';
/*Sliders*/
import './components/teams.component.js';
import './components/markets.component.js';
import './components/services.component.js';
import './components/meta-select.component.js';
import './components/jobs-search.component.js';
import './components/portal.component.js';
import './components/login-form.component.js';
import './components/swiper-bulletins.component.js';
import './components/swiper-clients.component.js';

import './components/swiper-clients-say.component.js';
import './components/swiper-trusted.component.js';
import './components/swiper-case-studies.component.js';
import './components/swiper-our-values.component.js';
import './components/swiper-gallery.component.js';
import './components/swiper-logos.component.js';
import './components/swiper-history.component.js';
import './components/swiper-jobs.component.js';
/*Sliders End*/

import './components/overlayScroll.component.js';

import './libs/countUp.lib.js';

window.jsScrollToEl = function jsScrollToEl(targetID) {
  let config = targetID.split('|');
  let duration = +config[1] && +config[1] !== '' ? +config[1] : 800;
  let paddingTop = +config[2] && +config[2] !== '' ? +config[2] : 0;
  let target = config[0];
  let targetElement = document.querySelector(target);

  if (targetElement) {
    let targetOffsetTop = targetElement.offsetTop - paddingTop;
    window.scrollTo({
      top: targetOffsetTop,
      behavior: 'smooth',
    });
    return false;
  }
};
